"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("underscore");

var _utils = require("../../utils/utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIconRating = _interopRequireDefault(require("UIComponents/input/UIIconRating"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var RATING_ICON_SIZE = 'xxs';
var getI18nKey = (0, _underscore.memoize)(function (path) {
  return "MarketplaceUI.goodDetailsPage." + path;
});

var GoodRatingInfo =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GoodRatingInfo, _PureComponent);

  function GoodRatingInfo() {
    (0, _classCallCheck2.default)(this, GoodRatingInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoodRatingInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(GoodRatingInfo, [{
    key: "render",
    value: function render() {
      var goodDetails = this.props.goodDetails;
      var reviewsCount = goodDetails.get('reviews').size;
      var renderedRating;

      if ((0, _utils.isBelowMinimumRequiredReviews)(reviewsCount)) {
        renderedRating = _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('reviews.noRatings')
        });
      } else {
        renderedRating = [_react.default.createElement(_UIIconRating.default, {
          key: "rating",
          disabled: true,
          iconSize: RATING_ICON_SIZE,
          showPercentage: true,
          value: goodDetails.get('averageRating')
        }), _react.default.createElement("span", {
          key: "reviews",
          className: "m-left-2"
        }, "(", reviewsCount, ")")];
      }

      return _react.default.createElement(_UIFlex.default, {
        align: "center",
        className: "m-left-4"
      }, renderedRating);
    }
  }]);
  return GoodRatingInfo;
}(_react.PureComponent);

GoodRatingInfo.propTypes = {
  goodDetails: _propTypes.default.instanceOf(_immutable.default.Map).isRequired
};
var _default = GoodRatingInfo;
exports.default = _default;
module.exports = exports.default;